import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const catalogAdminProductEditAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.CatalogAdminViewAccess,
}
